// Taşeron portalı — Belge Analizi sayfa (page) görselleri: kaynak-belge JOIN'i (S24,
// `docs/reviews/S24-result-list-design.md` §5/§"page distribution — one JOIN, in one
// place"). `DocumentAnalysisPageDto` artık `@isgportal/shared`'ın barrel'ından (`core.ts`)
// doğrudan AD ile import edilir — eskiden burada yerel bir indexed-access takma adıyla
// (`DocumentAnalysisDetailDto['pages'][number]`) türetiliyordu; barrel gap kapatıldığı için
// bu dolaylama artık gerekmiyor.
import type { DocumentAnalysisPageDto } from '@isgportal/shared';

/**
 * §20 `DocumentAnalysisPageDto` yorumundaki JOIN kuralı, TEK yerde: `sourceDocumentUuid`
 * `null` olan sayfalar SESSİZCE düşer (JOIN anahtarı DEĞİLDİR — atfedilemeyen bir sayfayı
 * her atfedilemeyen kaleme göstermek yanlış olurdu; brief §G).
 */
export function groupPagesBySource(
  pages: DocumentAnalysisPageDto[],
): Map<string, DocumentAnalysisPageDto[]> {
  const map = new Map<string, DocumentAnalysisPageDto[]>();
  for (const page of pages) {
    if (page.sourceDocumentUuid === null) {
      continue;
    }
    const list = map.get(page.sourceDocumentUuid);
    if (list) {
      list.push(page);
    } else {
      map.set(page.sourceDocumentUuid, [page]);
    }
  }
  return map;
}

/**
 * Bir kalemin sayfa alt kümesi — kalemin KENDİ `sourceDocumentUuid` + `pages[]`'ine göre
 * süzülmüş, kalemin `pages[]` SIRASINDA (zaten artan, §20 `DocumentAnalysisItemDto.pages`
 * yorumu). Çağıran (eskiden `DocumentAnalysisResultPage`, şimdi `AnalysisReviewPane`) bu
 * JOIN'i BİR KEZ (`groupPagesBySource` + bu fonksiyon) hesaplar; kart bunu İKİNCİ kez
 * FİLTRELEMEZ (brief §G).
 */
export function pagesForItem(
  pagesBySource: Map<string, DocumentAnalysisPageDto[]>,
  sourceDocumentUuid: string | null,
  itemPages: number[],
): DocumentAnalysisPageDto[] {
  if (sourceDocumentUuid === null) {
    return [];
  }
  const bySource = pagesBySource.get(sourceDocumentUuid);
  if (!bySource || bySource.length === 0) {
    return [];
  }
  const byNumber = new Map(bySource.map((p) => [p.pageNumber, p]));
  const result: DocumentAnalysisPageDto[] = [];
  for (const n of itemPages) {
    const page = byNumber.get(n);
    if (page) {
      result.push(page);
    }
  }
  return result;
}

/**
 * "Sayfa 3–4" (ardışık) / "Sayfa 3, 7" (değil) — tasarım §9. C14'te (plan S25) eski
 * `DocumentAnalysisItemCard.tsx`'ten TAŞINDI: dosya silindi, üç canlı tüketicisi
 * (`AnalysisInboxRail.tsx`, `AnalysisReviewPane.tsx`, `DocumentAnalysisPreview.tsx`) artık
 * buradan import ediyor.
 */
export function formatPageSpan(pages: number[]): string | null {
  if (pages.length === 0) {
    return null;
  }
  const sorted = [...pages].sort((a, b) => a - b);
  const first = sorted[0];
  const last = sorted[sorted.length - 1];
  if (first === undefined || last === undefined) {
    return null;
  }
  if (sorted.length === 1) {
    return String(first);
  }
  let contiguous = true;
  for (let i = 1; i < sorted.length; i += 1) {
    const prev = sorted[i - 1];
    const curr = sorted[i];
    if (prev === undefined || curr === undefined || curr !== prev + 1) {
      contiguous = false;
      break;
    }
  }
  return contiguous ? `${first}–${last}` : sorted.join(', ');
}
